import { render } from "./About.vue?vue&type=template&id=627bf48c"
const script = {}
script.render = render

export default script